<template>
  <div class="row">
    <div class="col-12 text-right d-flex justify-content-end">
      <b-button
        size="sm"
        variant="primary"
        class="mr-2"
        @click="changeTab(currentActive--)"
        v-if="currentActive > 1"
      >
        Previous
      </b-button>
      <b-button
        size="sm"
        variant="primary"
        class="mr-2"
        @click="changeTab(currentActive++)"
        v-if="currentActive < totalTabs"
      >
        Next
      </b-button>
      <appModalEMTestRun
        class="mr-2"
        v-if="currentActive == totalTabs"
      ></appModalEMTestRun>
      <b-button
        size="sm"
        variant="primary"
        class="mr-3"
        v-if="currentActive == totalTabs"
        @click="fnSubmit()"
        ><b-spinner v-if="isSpinner" small class="mr-2"></b-spinner
        >Submit</b-button
      >
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import * as emService from '../../services/em.service'
import * as messageService from '../../services/message.service'
import appModalEMTestRun from '../../components/emailMarketing/ModalEMTestRun.vue'
export default {
  name: 'EMWizardNavBar',
  components: {
    appModalEMTestRun
  },
  data() {
    return {
      totalTabs: 3,
      currentActive: 1,
      isSpinner: false,
      testUser: ''
    }
  },
  computed: {
    ...mapGetters(['getEMWizardStep', 'getEMWizardData', 'getEmployerPaginate'])
  },
  methods: {
    ...mapActions(['fetchEMWizardStep', 'fetchEMWizardData']),
    changeTab() {
      this.fetchEMWizardStep(this.currentActive)
      return this.currentActive
    },
    async fnSubmit() {
      this.isSpinner = true
      try {
        let obj = {
          runMode: 'production',
          employerPaginate: this.getEmployerPaginate
        }
        await this.fetchEMWizardData({ ...this.getEMWizardData, ...obj })

        await emService.wizardPost(this.getEMWizardData)
        messageService.fnSweetAlertSuccessToast('EM', 'Send successfully ')
        this.isSpinner = false
      } catch (error) {
        messageService.fnSweetAlertErrorToast('EM', error.response.data.message)
        this.isSpinner = false
      }
    }
  },
  watch: {
    getEMWizardStep(newVale) {
      this.currentActive = newVale
    }
  }
}
</script>
